/**
 * Dedupe job applicant rows from GET .../jobs/applicants/.../all.
 * Handles API quirks: same logical row repeated with number vs string IDs, or duplicate user rows.
 */

export function dedupeJobApplicantRecords<T extends {
  applicationId?: number | string | null;
  userId?: number | string | null;
}>(records: T[]): T[] {
  const seenApplicationIds = new Set<string>();
  const seenUserIds = new Set<string>();

  return records.filter((row) => {
    const rawAppId = row.applicationId;
    const rawUserId = row.userId;

    const hasAppId =
      rawAppId !== undefined && rawAppId !== null && String(rawAppId).trim() !== "";
    const hasUserId =
      rawUserId !== undefined && rawUserId !== null && String(rawUserId).trim() !== "";

    if (!hasAppId && !hasUserId) {
      return true;
    }

    const appKey = hasAppId ? `app:${String(rawAppId)}` : null;
    const userKey = hasUserId ? `user:${String(rawUserId)}` : null;

    if (appKey && seenApplicationIds.has(appKey)) {
      return false;
    }
    if (userKey && seenUserIds.has(userKey)) {
      return false;
    }

    if (appKey) seenApplicationIds.add(appKey);
    if (userKey) seenUserIds.add(userKey);
    return true;
  });
}
